import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  Checkbox,
  AccordionDetails,
  TableRow,
  useTheme,
  tableCellClasses,
  TableCell,
  Grid,
  Chip,
  Avatar,
} from "@mui/material";
import KeyIcon from "@mui/icons-material/VpnKey";
import ButtonContained from "../../../Common/ButtonContained";
import ButtonOutlined from "../../../Common/ButtonOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { showLoader } from "../../../../Redux/Slices/loaderSlice";
import ErrorHandler, {
  capitalizeFirstLetterOfWords,
  checkAccess,
  CommonChip,
  CustomTooltip,
} from "../../../../Utils/handler";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  active_inactive_member,
  active_inactive_member_Deactive,
  add_extra_userType,
  add_role_access,
  addRole,
  delete_extra_userType,
  get_available_access,
  get_dynamic_role_list,
  get_role_access,
  get_user_list,
  getAvailableAccess,
  getMemberByMobileNumber,
  inactive_user_list,
  update_role_access,
} from "../../../../Redux/Actions/action";
import { useLocation, useNavigate } from "react-router";
import TextLabel from "../../../Common/CommonTextLabel";
import CustomDialog from "../../../Common/CustomDialog";
import CommonTextField from "../../../Common/CommonTextField";
import AutoCompleteSearch from "../../../Common/AutoCompleteSearch";
import { BucketURL } from "../../../../ApiSetup/Api";
import sessionStoreUtil from "../../../../ApiSetup/Localstorage";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomPagination from "../../../Common/CommonPagination";
import { useSelector } from "react-redux";
import CommonSearchField from "../../../Common/CommonSearchField";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const roles = [
  { name: "Admin", members: 2, canDelete: false },
  { name: "Staff", members: 23, canDelete: false },
  { name: "Sarthi", members: 100, canDelete: true },
  { name: "Sarthi Level 2", members: 100, canDelete: false },
];

const Accordion = styled(MuiAccordion)(({ theme }) => ({
  borderRadius: "5px",
  overflow: "hidden",
  marginBottom: 5,
  border: "1px solid rgba(0, 0, 0, .125)",
  // boxShadow: 'none',
  "&:not(:last-child)": {
    // borderBottom: 0,
  },
  "&:before": {
    display: "none",
    marginBottom: 5,
  },
  "&.Mui-expanded": {
    marginBottom: 15,
    margin: "6px 0px",
  },
}));

const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  backgroundColor: "#e6e6e6",
  borderBottom: "1px solid rgba(0, 0, 0, .125)",
  // color: "white",
  minHeight: 40,
  "&.Mui-expanded": {
    minHeight: 40,
  },
  "& .MuiAccordionSummary-content": {
    margin: "0px",
    "&.Mui-expanded": {
      margin: "0px",
    },
  },
}));

const AccordionSummaryPermissions = styled(MuiAccordionSummary)(
  ({ theme }) => ({
    backgroundColor: "#f2f2ff",
    // borderBottom: '1px solid rgba(0, 0, 0, .125)',
    // color: "white",
    minHeight: 60,
    "&.Mui-expanded": {
      minHeight: 60,
    },
    "& .MuiAccordionSummary-content": {
      margin: "0px",
      "&.Mui-expanded": {
        margin: "0px",
      },
    },
  })
);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme?.palette?.bgLightWhite?.main,
    fontSize: 15,
    textAlign: "center", // Horizontally align content
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "2px !important",
    textAlign: "center", // Horizontally align content
  },
  // "&:last-of-type": {
  //     borderBottom: "none", // Remove bottom border for the last cell
  // },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-of-type td, &:last-of-type th": {
    borderBottom: "none", // Remove bottom border for the entire last row
  },
}));

const RolePermissions = () => {
  // ---------- Hook -----------
  const dispatch = useDispatch();
  const theme = useTheme();
  const { pathname } = useLocation();

  // --------------- State -------------
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [data, setData] = useState();
  const [dynamicRoleList, setDynamicRoleList] = useState([]);
  const [page, setPage] = useState(1);
  // const [userListPage, setUserListPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState({
    index: null,
    selectedTab: "",
  });
  const [memberList, setMemberList] = useState([]);
  const [selectedRole, setSelectedRole] = useState({});
  const [searchValue, setSearchValue] = useState({});
  const [serachUserList, setSerachUserList] = useState([]);
  const [error, setError] = useState({});
  const [open, setOpen] = useState(false);
  const [addRoleData, setAddRoleData] = useState({
    newRole: "",
    organisationName: "",
  });
  const [timer, setTimer] = useState(0);
  const user = sessionStoreUtil.getLSItem("userData")
    ? JSON.parse(sessionStoreUtil.getLSItem("userData"))
    : {};
  const [isInActive, setIsInActive] = useState(false);
  const [inActiveList, setInActiveList] = useState([]);
  const [searchText, setSearchText] = useState("");

  const dataAccess = useSelector(
    (value) => value?.allAvailableAccess?.AllAvailableAccessList
  );

  // --------------- handleChange ---------------
  // Handle click on the "Permissions" button
  const handlePermissionsClick = () => {
    setIsTableVisible((prevState) => !prevState);
  };

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const configDynamicRole =
    user.loginRole !== "SuperAdmin"
      ? dynamicRoleList?.filter((e) => e?.userType != "SuperAdmin")
      : dynamicRoleList;

  const handleChange = (pageIndex, actionIndex, role) => {
    setData((prevData) => {
      const newData = [...prevData]; // Clone current state
      const page = newData[pageIndex]; // Get the specific page
      const action = page.actions[actionIndex]; // Get the specific action

      // Toggle the role value
      action.roles[role] = !action.roles[role];

      // Prepare payload to send the entire page's updated data
      const updatedPage = {
        pageName: page.pageName,
        actions: page.actions.map((action) => ({
          actionName: action.actionName,
          roles: action.roles,
        })),
      };

      // Make API call to update the page data
      updatePageAccess(updatedPage);

      return newData; // Update the state
    });
  };

  const handleAccordionClick = (userName, index) => {
    if (openAccordion === index) {
      setActiveAccordion({ index: null, selectedTab: "" });
      setOpenAccordion(null);
      setMemberList([]);
    } else {
      setSerachUserList([]);
      setMemberList([]);
      setActiveAccordion({ index: index, selectedTab: userName });
      setOpenAccordion(index);
      _getUserList(userName);
    }
  };

  const handleClear = () => {
    setOpen(false);
    setAddRoleData({ newRole: "" });
    setError({});
  };

  // --------------- API---------------

  const _getRoleList = async () => {
    dispatch(showLoader(true));
    let body = {
      // page: page,
      // limit: rowsPerPage
    };
    try {
      const result = await dispatch(get_role_access(body));
      const error = ErrorHandler(result);
      if (error) {
        setData(result?.payload?.data?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const updatePageAccess = async (updatedPage) => {
    try {
      dispatch(showLoader(true));
      const body = {
        pageName: updatedPage?.pageName,
        actions: updatedPage?.actions,
      };
      const result = await dispatch(update_role_access(body)); // API call
      const error = ErrorHandler(result);

      if (error) {
        toast.success(
          result?.payload?.message || "Page data updated successfully"
        );
        await _getRoleList();
      }
    } catch (error) {
      toast.error(error?.message || "Failed to update page data");
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _getDynamicRoleList = async () => {
    dispatch(showLoader(true));
    let body = {
      // page: page,
      // limit: rowsPerPage
    };
    try {
      const result = await dispatch(get_dynamic_role_list(body));
      const error = ErrorHandler(result);
      if (error) {
        setDynamicRoleList(result?.payload?.data?.response);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _getUserList = async (userName) => {
    dispatch(showLoader(true));
    let body = {
      userType: userName,
      page: page,
      limit: rowsPerPage,
    };
    try {
      const result = await dispatch(get_user_list(body));
      const error = ErrorHandler(result);
      if (error) {
        setMemberList(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _getInActiveUserList = async () => {
    dispatch(showLoader(true));
    let body = {
      userType: "User",
      page: page,
      limit: rowsPerPage,
      search: searchText,
    };
    try {
      const result = await dispatch(inactive_user_list(body));
      const error = ErrorHandler(result);
      if (error) {
        setInActiveList(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _getAllMember = async (search) => {
    dispatch(showLoader(true));
    let body = {
      page: 1,
      limit: 10,
      search: search,
    };
    try {
      const result = await dispatch(getMemberByMobileNumber(body));
      const error = ErrorHandler(result);
      if (error) {
        setSearchValue(search ? search : "");
        setSerachUserList(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _addExtraUserType = async (role, organisationName) => {
    if (!selectedRole) {
      setError({ role: "please select any one member" });
      return;
    }
    try {
      dispatch(showLoader(true));
      const body = {
        _id: selectedRole?._id,
        userType: role,
        organisationName: organisationName,
      };
      const result = await dispatch(add_extra_userType(body)); // API call
      const error = ErrorHandler(result);
      if (error) {
        console.log(result, "resultsdsd");
        setSelectedRole({});
        toast.success(
          result?.payload?.message || "Page data updated successfully"
        );
        _getDynamicRoleList();
        _getUserList(role);
      }
    } catch (error) {
      toast.error(error?.message || "Failed to update page data");
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _active_inactive_member = async (id, role) => {
    try {
      dispatch(showLoader(true));
      const body = {
        _id: id,
      };
      const result = await dispatch(active_inactive_member(body)); // API call
      const error = ErrorHandler(result);
      if (error) {
        toast.success(
          result?.payload?.message || "Page data updated successfully"
        );
        isInActive ? _getInActiveUserList() : _getUserList(role);
        _getUserList(role);
        _getDynamicRoleList();
      }
    } catch (error) {
      toast.error(error?.message || "Failed to update page data");
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _active_inactive_member_Deactive = async (id, role) => {
    try {
      dispatch(showLoader(true));
      const body = {
        _id: id,
        isDeleted: false,
      };
      const result = await dispatch(active_inactive_member_Deactive(body)); // API call
      const error = ErrorHandler(result);
      if (error) {
        toast.success(
          result?.payload?.message || "Page data updated successfully"
        );
        isInActive ? _getInActiveUserList() : _getUserList(role);
        _getUserList(role);
        _getDynamicRoleList();
      }
    } catch (error) {
      toast.error(error?.message || "Failed to update page data");
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _addNewRole = async () => {
    if (!addRoleData?.newRole || !addRoleData?.organisationName) {
      setError({
        newRole: "*Please enter role",
        organisationName: "*Please enter organisation",
      });
      return;
    }
    dispatch(showLoader(true));
    try {
      let body = {
        roleName: addRoleData?.newRole,
        organisationName: addRoleData?.organisationName,
      };
      const result = await dispatch(addRole(body));
      const error = ErrorHandler(result);
      if (error) {
        toast.success(result?.payload?.message);
        _getDynamicRoleList();
        handleClear();
      }
    } catch (error) {
      toast.error(error?.message || "An unknown error occurred");
    } finally {
      dispatch(showLoader(false));
    }
  };

  // ---------- useEffect ------------
  useEffect(() => {
    _getRoleList();
    _getDynamicRoleList();
  }, []);

  useEffect(() => {
    _getInActiveUserList();
  }, [page, rowsPerPage, searchText]);

  useEffect(() => {
    if (activeAccordion.selectedTab) {
      _getUserList(activeAccordion.selectedTab);
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    dispatch(showLoader(true));
    dispatch(getAvailableAccess())
      .unwrap() // Automatically handles async response
      .catch((error) => console.error("error", error))
      .finally(() => dispatch(showLoader(false)));
  }, [data]);

  console.log(inActiveList, "inActiveList");
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f8f8f8",
          padding: "18px",
          borderRadius: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {(isTableVisible || isInActive) && (
                <ArrowBackIcon
                  sx={{
                    color: theme.palette.primary.main,
                    fontSize: "25px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setIsTableVisible(false);
                    _getUserList(activeAccordion.selectedTab);
                    setIsInActive(false);
                    setSearchText("");
                  }}
                />
              )}
              <Typography sx={{ fontSize: "20px", fontWeight: 500 }}>
                {" "}
                {isInActive ? "Deactivated Users" : "Role & Permission"}
              </Typography>
            </Box>
            {isInActive && (
              <>
                <Typography variant="caption" color="orange" gutterBottom>
                  Note: Below users are deactivated. You can activate them by
                  clicking on the right icon on the chip.
                </Typography>
                <Typography variant="caption" color="orange" gutterBottom>
                  Note: નીચેના યુઝર્સ નિષ્ક્રિય છે. તમે ચિપ પર જમણી બાજુના آئકન
                  પર ક્લિક કરીને તેમને સક્રિય કરી શકો છો.
                </Typography>
              </>
            )}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {checkAccess(pathname, dataAccess, "Deactivated Users") &&
              !isInActive && (
                <ButtonOutlined
                  variant={"text"}
                  height="30px"
                  borderRadius={"5px"}
                  color={"primary"}
                  text="Show Deactivated Users"
                  onClick={() => {
                    setIsInActive(true);
                    _getInActiveUserList();
                  }}
                />
              )}
            {checkAccess(pathname, dataAccess, "AddNewRole") && !isInActive && (
              <ButtonContained
                text="Add New Role"
                height={"30px"}
                borderRadius={"5px"}
                onClick={() => setOpen(true)}
              />
            )}
          </Box>
          {isInActive && (
            <CommonSearchField
              placeholder={"Search.."}
              tooltipList={["First Name", "Last Name"]}
              handleSearch={(e) => {
                setPage(1);
                setSearchText(e);
              }}
            />
          )}
        </Box>

        {/* Roles List */}

        {isInActive ? (
          <>
            <Box display={"flex"} gap={1} flexWrap={"wrap"}>
              {inActiveList?.response?.map((chip, i) => {
                const name =
                  chip?.personalDetails?.fullName;
                return (
                  chip?.personalDetails?.fullName && <Chip
                    key={i}
                    label={capitalizeFirstLetterOfWords(name)}
                    onDelete={() =>
                      _active_inactive_member_Deactive(chip?._id, "User")
                    }
                    deleteIcon={<CheckCircleIcon />}
                    sx={{
                      "& .MuiChip-label ": {
                        color: theme.palette.primary.main,
                      },
                      "& .MuiChip-deleteIcon ": {
                        color: theme.palette.success.light,
                      },
                      height: "30px",
                    }}
                  />
                );
              })}
            </Box>
            {inActiveList?.response?.length > 0 && (
              <Box>
                <CustomPagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  count={Math.ceil(inActiveList?.count / rowsPerPage)}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Box>
            )}
          </>
        ) : isTableVisible ? (
          <>
            <Box my={2}>
              <Table>
                <TableHead
                  sx={{
                    backgroundColor: theme?.palette?.primary?.main,
                    "& th": { color: "#fff" },
                  }}
                >
                  <TableRow sx={{ borderRadius: "10px", overflow: "hidden" }}>
                    <StyledTableCell
                      align="center"
                      sx={{
                        maxWidth: "30px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "8px",
                      }}
                    >
                      Page
                    </StyledTableCell>
                    {data?.length > 0 &&
                      Object.keys(data?.[0]?.actions?.[0]?.roles)?.map(
                        (role) => {
                          if (role !== "SuperAdmin") {
                            return (
                              <StyledTableCell
                                align={"center"}
                                sx={{ maxWidth: "50px" }}
                                key={role}
                              >
                                {role}
                              </StyledTableCell>
                            );
                          }
                        }
                      )}
                  </TableRow>
                </TableHead>
              </Table>

              {data?.map((page, pageIndex) => (
                <Accordion key={page._id} elevation={0}>
                  <AccordionSummary>
                    <ExpandMoreIcon color="primary" />{" "}
                    <Typography ml={1} fontSize={"15px"} color={"primary"}>
                      {page?.pageName}
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails sx={{ padding: "0px 8px" }}>
                    <Table>
                      <TableBody>
                        {page?.actions?.map((action, actionIndex) => {
                          console.log(action.roles, "action");
                          const roleKeys = Object.keys(action.roles);

                          return (
                            <StyledTableRow key={action._id}>
                              <StyledTableCell sx={{ maxWidth: "30px" }}>
                                <CustomTooltip title={action?.actionName}>
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      textAlign: "start",
                                    }}
                                  >
                                    {action?.actionName}
                                  </Typography>
                                </CustomTooltip>
                              </StyledTableCell>

                              {roleKeys?.map((role) => {
                                if (role !== "SuperAdmin") {
                                  return (
                                    <StyledTableCell key={role} align="center">
                                      <Checkbox
                                        checked={action.roles[role] || false}
                                        onChange={() =>
                                          handleChange(
                                            pageIndex,
                                            actionIndex,
                                            role
                                          )
                                        }
                                      />
                                    </StyledTableCell>
                                  );
                                }
                              })}
                            </StyledTableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </>
        ) : (
          <>
            {configDynamicRole?.map((role, index) => {
              return (
                <Accordion
                  key={index}
                  elevation={0}
                  expanded={activeAccordion.index === index}
                  sx={{ boxShadow: 0 }}
                >
                  <AccordionSummaryPermissions
                    onClick={() => {
                      handleAccordionClick(role?.userType, index);
                      setSelectedRole({});
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box display={"flex"} alignItems={"center"} gap={1}>
                        <ExpandMoreIcon color="primary" />
                        <Box>
                          <Typography
                            color={theme.palette.primary.main}
                            lineHeight={"1.2rem"}
                            sx={{ fontWeight: 600, fontSize: "16px" }}
                          >
                            {role?.userType}
                          </Typography>
                          <Typography
                            color={theme.palette.primary.main}
                            lineHeight={"1.2rem"}
                            sx={{
                              fontSize: "14px",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            {role?.totalCount} Members
                          </Typography>
                        </Box>
                      </Box>
                      {checkAccess(pathname, dataAccess, "Permissions") && (
                        <Box sx={{ display: "flex", gap: "8px" }}>
                          <ButtonOutlined
                            variant={"text"}
                            height="30px"
                            borderRadius={"5px"}
                            startIcon={<KeyIcon />}
                            text="Permissions"
                            onClick={handlePermissionsClick}
                          />
                        </Box>
                      )}
                    </Box>
                  </AccordionSummaryPermissions>

                  <AccordionDetails sx={{ padding: "0px 8px" }}>
                    <Table>
                      <TableBody>
                        <Grid
                          container
                          spacing={2}
                          padding={"10px"}
                          alignItems="center"
                        >
                          {role?.userType !== "User" && (
                            <>
                              <Grid item xs={6}>
                                <AutoCompleteSearch
                                  width={"100%"}
                                  placeholder={"Select Role"}
                                  handleChange={(e, newValue) => {
                                    if (!newValue) {
                                      _getAllMember();
                                    } else {
                                      setSelectedRole(newValue);
                                    }
                                  }}
                                  options={serachUserList?.response || []}
                                  getOptionLabel={(option) =>
                                    capitalizeFirstLetterOfWords(
                                      option?.fullName
                                    ) ||
                                    option?.phoneNumber ||
                                    ""
                                  }
                                  handleSearch={(ev) => {
                                    let val = ev?.target?.value || "";
                                    clearTimeout(timer);
                                    setTimer(
                                      setTimeout(() => {
                                        _getAllMember(val);
                                      }, 500)
                                    );
                                  }}
                                  searchValue={searchValue || ""}
                                  // loadData={(serachUserList?.response?.length !== serachUserList?.count) ? _getAllMember() : undefined}
                                  name="selectedRole"
                                  defaultValue={selectedRole || null}
                                  value={selectedRole || null}
                                  labelSize={"12px"}
                                  fontWeight={400}
                                  filterOptions={(options) => options}
                                  renderOption={(props, option) => {
                                    return (
                                      <li
                                        {...props}
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        <Box display={"flex"} gap={1}>
                                          <Avatar
                                            src={BucketURL + option?.avtar}
                                            alt="image"
                                            sx={{ cursor: "pointer" }}
                                            slotProps={{
                                              loading: "lazy",
                                              cursor: "pointer",
                                            }}
                                          />
                                          <Box>
                                            <Box
                                              display={"flex"}
                                              width={"100%"}
                                              flexWrap={"wrap"}
                                            >
                                              <Typography
                                                color={
                                                  theme.palette.primary.main
                                                }
                                                fontSize={"14px"}
                                                fontWeight={500}
                                              >
                                                {capitalizeFirstLetterOfWords(
                                                  option?.fullName
                                                )}
                                              </Typography>
                                            </Box>
                                            <Box display={"flex"} gap={0.5}>
                                              <Typography
                                                color={
                                                  theme.palette.primary.main
                                                }
                                                fontSize={"12px"}
                                                fontWeight={550}
                                              >
                                                +91 {option?.phoneNumber}
                                              </Typography>
                                              <CommonChip
                                                label={
                                                  option?.verificationStatus
                                                }
                                                status={
                                                  option?.verificationStatus
                                                }
                                                height={"18px"}
                                                fontSize="12px"
                                              />
                                            </Box>
                                          </Box>
                                        </Box>
                                      </li>
                                    );
                                  }}
                                />
                                <TextLabel
                                  color="error"
                                  title={!selectedRole ? error?.role : ""}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <ButtonContained
                                  width={"auto"}
                                  text={"Assign Role"}
                                  padding={"10px 9px"}
                                  fontSize={{ xs: "12px", md: "14px" }}
                                  height={"30px"}
                                  onClick={() =>
                                    _addExtraUserType(
                                      role?.userType,
                                      role?.organisationName
                                    )
                                  }
                                  disabled={!selectedRole?._id}
                                />
                              </Grid>
                            </>
                          )}

                          <Grid container spacing={1} item xs={12}>
                            {memberList?.users?.map((chip, i) => {
                              console.log("user",chip)
                              const name =
                                chip?.fullName;
                              return (
                                <Grid item>
                                  <Chip
                                    key={i}
                                    label={capitalizeFirstLetterOfWords(name)}
                                    onDelete={() =>
                                      _active_inactive_member(
                                        chip?._id,
                                        role?.userType
                                      )
                                    }
                                    sx={{
                                      "& .MuiChip-label ": {
                                        color: theme.palette.primary.main,
                                      },
                                      "& .MuiChip-deleteIcon ": {
                                        color: theme.palette.error.light,
                                      },
                                      height: "30px",
                                    }}
                                  />
                                </Grid>
                              );
                            })}
                          </Grid>

                          {role?.userType === "User" && (
                            <Grid item xs={12}>
                              {dynamicRoleList?.length > 0 && (
                                <Grid item xs={12}>
                                  <CustomPagination
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    count={Math.ceil(
                                      role?.totalCount / rowsPerPage
                                    )}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={
                                      handleChangeRowsPerPage
                                    }
                                  />
                                </Grid>
                              )}
                            </Grid>
                          )}
                        </Grid>
                      </TableBody>
                    </Table>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </>
        )}
      </Box>

      {open && (
        <CustomDialog
          isOpen={open}
          handleClose={handleClear}
          title={"Add New Role"}
          padding={"10px"}
          width={400}
          action={
            <ButtonContained
              text={"Add Role"}
              onClick={_addNewRole}
              minWidth={"100%"}
              marginTop={"10px"}
            />
          }
        >
          <Grid container spacing={2} xs={12}>
            <Grid item xs={12}>
              <CommonTextField
                value={data?.question}
                width={"100%"}
                text="New Role"
                type="text"
                onChange={(e) => {
                  setAddRoleData({ ...addRoleData, newRole: e.target.value });
                }}
                placeholder="Enter a New Role"
                name="newRole"
                valid
              />
              <TextLabel
                title={!addRoleData?.newRole ? error?.newRole : ""}
                color="error"
              />
            </Grid>
            <Grid item xs={12}>
              <CommonTextField
                value={data?.organisationName}
                width={"100%"}
                text="New Organisation"
                type="text"
                onChange={(e) => {
                  setAddRoleData({
                    ...addRoleData,
                    organisationName: e.target.value,
                  });
                }}
                placeholder="Enter a New Organisation"
                name="organisationName"
                valid
              />
              <TextLabel
                title={
                  !addRoleData?.organisationName ? error?.organisationName : ""
                }
                color="error"
              />
            </Grid>
          </Grid>
        </CustomDialog>
      )}
    </>
  );
};

export default RolePermissions;
